import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type.ts';
import { fetchApi } from '@/config/axiosSetting.ts';

type ResponseType = Promise<
  PaginationResponseType<{ id: number; name: string }[]>
>;
export const countyRequest = ({
  province,
  countyName,
}: {
  province?: number;
  countyName: string | null;
}): ResponseType => {
  return fetchApi({
    method: 'GET',
    url: 'selection_item/county/list/',
    params: { province, name: countyName },
  });
};
